<template lang="pug">
  .w-100.mh-100.h-100
    div.py-2(style="font-size: 14px")
      .p-0(v-if="!reportData.IsSummary") Геозона: {{reportData.Data.Data.GeofenceName}}
      .p-0(v-if="reportData.IsSummary && reportData.Data.Data[0]") Геозона: {{reportData.Data.Data[0].GeofenceName}}
    dx-data-grid(ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localGeoHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'GeofenceVisits',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'Date',
        caption: 'Дата',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
        width: 120,
      }, {
        dataField: 'Begin',
        caption: 'Первый заезд',
        alignment: 'center',
        width: 150,
      }, {
        dataField: 'End',
        caption: 'Последний выезд',
        alignment: 'center',
        width: 150,
      }, {
        dataField: 'AverageSpeed',
        caption: 'Средняя скорость, км/ч',
      }, {
        dataField: 'MaxSpeed',
        caption: 'Максимальная скорость, км/ч',
      }, {
        dataField: 'MileageKm',
        caption: 'Пробег, км',
        alignment: 'center',
        width: 120,
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'MaxSpeed',
        name: 'MaxSpeed',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'AverageSpeed',
        name: 'AverageSpeed',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'MileageKm',
        name: 'MileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      summary: null,
      rowClick: null,
      reportSummary: [],
      index: 0,
    };
  },
  computed: {
    localGeoHeight () {
      return `calc(${this.localHeight} - 37px)`;
    },
  },
  watch: {
    reportData (value) {
      this.sortableField = null;
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
      this.getSummary();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.getSummary();
  },
  methods: {
    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((items) => {
        items.Rows.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
      });
      this.reportSummary = rows;
    },

    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              const totalValue = options.name === 'MileageKm' ? this.reportData.Data.Data[`Sum${options.name}`] : this.reportData.Data.Data[`${options.name}`];
              if (totalValue !== undefined) {
                value.totalValue = totalValue.toFixed(2);
              }
            }
          },
          totalItems: this.summaryColoumn,
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              if (options.groupIndex === undefined) {
                const totalValue = options.name === 'MileageKm' ? this.reportData.Data[`Sum${options.name}`] : this.reportData.Data[`${options.name}`];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue.toFixed(2);
                }
                this.index = 0;
              } else {
                value.totalValue = (options.name !== 'MileageKm' ? this.reportData.Data.Data[this.index][`${options.name}`] : this.reportData.Data.Data[this.index]?.SumMileageKm).toFixed(2);
                if (options.name === 'MileageKm') {
                  this.index += 1;
                }
              }
            }
          },
          totalItems: this.summaryColoumn,
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      }
    },
  },
};
</script>
